import { render, staticRenderFns } from "./NeighbourhoodScene.vue?vue&type=template&id=55a1e19f&"
import script from "./NeighbourhoodScene.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodScene.vue?vue&type=script&lang=js&"
import style0 from "./NeighbourhoodScene.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports